module.exports = __webpack_public_path__ + "static/Inter-ExtraBold-3343f7d676687fc454673f8ca96bc0ff.woff";